<template>
    <div v-if="activeStep !== 1" class="midblock floatleft relative width100">
        <div class="padding15 textleft dim">
            <div class="floatleft margintop10">
                Geselecteerd aantal personen:

                <span
                    class="bold"
                    v-for="(paxType, hutIndex) in payload.cabins"
                    :key="'cabin' + hutIndex"
                >
                    <span v-if="paxType.volwassenen > 0">
                        {{ paxType.volwassenen }} x volwassenen</span
                    >
                    <span v-if="paxType.jeugd > 0">
                        {{ paxType.jeugd }} x jeugd<span
                            v-if="paxType.jeugd > 1"
                            >igen</span
                        ></span
                    >
                    <span v-if="paxType.kinderen > 0">
                        {{ paxType.kinderen }} x kind<span
                            v-if="paxType.kinderen > 1"
                            >eren</span
                        ></span
                    >
                    <span v-if="paxType.baby > 0">
                        {{ paxType.baby }} x baby<span v-if="paxType.baby > 1"
                            >s</span
                        ></span
                    >
                </span>
            </div>

            <button
                v-on:click="setActiveStep(1)"
                type="button"
                id="testCabinConfigWijzigen"
                class="btn btn-success btn-addon font14 bold floatright editbutton"
            >
                Wijzigen
            </button>

            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CabinConfigInactive',
    props: {
        activeStep: Number,
        payload: Object,
        setActiveStep: Function,
    },
}
</script>
